import {BoardColumnHeader} from '@github-ui/board/frames'
import type {BoardColumn} from '@github-ui/board-core'

import {axisHeadingText, axisLeadingVisual} from './axis-heading'
import type {BoardAxisLabels} from './board-payload'

/**
 * A column heading for an issues board: the mark the grouping field gives this bucket, its
 * name, and the column's count.
 *
 * Everything but the count comes from the payload's own axis, so a bucket nothing sits in is
 * drawn the same as one that is full and a cell the board has not loaded costs nothing to
 * read. A column whose axis said nothing about it gets the plain heading, which is the name
 * the board already holds.
 *
 * Avatars and colours are decorative. A repository icon conveys state absent from the name,
 * so its text alternative is exposed to assistive technology.
 *
 * The name says the same thing `column.label` says either way, which is what every cell in
 * the column is named after.
 */
export function BoardColumnHeading({column, labels}: {column: BoardColumn; labels: BoardAxisLabels}) {
  const label = labels.get(column.key)

  return (
    <BoardColumnHeader column={column} {...axisLeadingVisual(label)}>
      {axisHeadingText(label)}
    </BoardColumnHeader>
  )
}
